import * as themeActions from "./themeCategory.action";

export const themeCategoryFeatureKey = "themeCategoryInfo";

const initialState = {
    loading: false,
    errorMsg: "",
    themeCategoryList: [],
    themeCategoryFullList: [],
    themeCategoryListTotal: [],
};

export const reducer = (state = initialState, { payload, type }) => {
    switch (type) {
        case themeActions.CREATE_THEME_CATEGORY_REQUEST:
            return {
                ...state,
                loading: true
            }

        case themeActions.CREATE_THEME_CATEGORY_SUCCESS:
            let createArr = state.themeCategoryList;
            createArr.unshift(payload.data);
            return {
                ...state,
                loading: false,
                themeCategoryList: createArr
            }

        case themeActions.CREATE_THEME_CATEGORY_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: payload
            }

        case themeActions.UPDATE_THEME_CATEGORY_REQUEST:
            return {
                ...state,
                loading: true
            }

        case themeActions.UPDATE_THEME_CATEGORY_SUCCESS:
            let findIndex = state.themeCategoryList.findIndex(o => o._id === payload.data._id);
            state.themeCategoryList.splice(findIndex, 1, payload.data);
            return {
                ...state,
                loading: false
            }

        case themeActions.UPDATE_THEME_CATEGORY_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: payload
            }

        case themeActions.DELETE_THEME_CATEGORY_REQUEST:
            return {
                ...state,
                loading: true
            }

        case themeActions.DELETE_THEME_CATEGORY_SUCCESS:
            const removeArr = state.themeCategoryList.filter(o => o._id !== payload);
            return {
                ...state,
                loading: false,
                themeCategoryList: removeArr
            }

        case themeActions.DELETE_THEME_CATEGORY_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: payload
            }

        case themeActions.LIST_THEME_CATEGORY_REQUEST:
            return {
                ...state,
                loading: true
            }

        case themeActions.LIST_THEME_CATEGORY_SUCCESS:
            return {
                ...state,
                loading: false,
                themeCategoryList: payload.data,
                themeCategoryFullList: payload.fullList,
                themeCategoryListTotal: payload.total
            }

        case themeActions.LIST_THEME_CATEGORY_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: payload
            }

        default: return state;
    }
};